export interface LoginUsingPOST {
  emailAddress: string;
  password: string;
  sendMFACode?: boolean;
}

export interface SendMFACodePost {
  code: string;
}

export interface Oauth2LoginPost {
  code: string;
  loginType: LoginType;
  redirectUri: string;
}

export enum LoginType {
  Okta = 'Okta',
  Microsoft = 'Microsoft',
}

export enum SsoParams {
  Code = 'code',
  State = 'state',
}
